export default __webpack_public_path__ + "static/media/logo.689eb6fc.png";